<template lang="pug">
div
  .mainWrapper
    .login
      .login-image
        .icon-login
      span.login-text 尋求更多真相
      button.login-button(@click="login") 登入
      span.login-footer © LINE Taiwan Limited
</template>
<script>
import { login } from '@/plugins/login.js'
export default {
  methods: {
    login() {
      login(this.$store.state)
    }
  }
}
</script>